module.exports = __webpack_public_path__ + "static/media/S1N8-3.b44f10ec.svg";